module.exports = __webpack_public_path__ + "static/img/left.fb36bd9.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/left.png
// module id = NqMD
// module chunks = 1